import { ISeniority } from "@/contracts/EmployeeContract";

export const seniorityMap: { [key: string]: ISeniority } = {
  JR: {
    Name: "Junior",
    Code: "JR",
    Order: 0
  },
  M1: {
    Name: "Medior 1",
    Code: "M1",
    Order: 1
  },
  M2: {
    Name: "Medior 2",
    Code: "M2",
    Order: 2
  },
  M3: {
    Name: "Medior 3",
    Code: "M3",
    Order: 3
  },
  S1: {
    Name: "Senior 1",
    Code: "S1",
    Order: 4
  },
  S2: {
    Name: "Senior 2",
    Code: "S2",
    Order: 5
  },
  S3: {
    Name: "Senior 3",
    Code: "S3",
    Order: 6
  },
  PR1: {
    Name: "Principal 1",
    Code: "PR1",
    Order: 7
  },
  PR2: {
    Name: "Principal 2",
    Code: "PR2",
    Order: 8
  },
  PR3: {
    Name: "Principal 3",
    Code: "PR3",
    Order: 9
  },
  JRCOM: {
    Name: "Junior Commercial",
    Code: "JRCOM",
    Order: 10
  },
  MCOM: {
    Name: "Medior Commercial",
    Code: "MCOM",
    Order: 11
  },
  SCOM:  {
    Name: "Senior Commercial",
    Code: "SCOM",
    Order: 12
  },
  CORE: {
    Name: "Core",
    Code: "CORE",
    Order: 13
  },
  ADV1: {
    Name: "Advanced 1",
    Code: "ADV1",
    Order: 14
  },
  ADV2: {
    Name: "Advanced 2",
    Code: "ADV2",
    Order: 15
  },
  ADV3: {
    Name: "Advanced 3",
    Code: "ADV3",
    Order: 16
  },
  PROF1: {
    Name: "Proficient 1",
    Code: "PROF1",
    Order: 17
  },
  PROF2: {
    Name: "Proficient 2",
    Code: "PROF2",
    Order: 18
  },
  OFF: {
    Name: "Officer",
    Code: "OFF",
    Order: 19
  },
  MGR: {
    Name: "Manager",
    Code: "MGR",
    Order: 20
  },
  DIR: {
    Name: "Director",
    Code: "DIR",
    Order: 21
  },
  ST: {
    Name: "Student Consultant",
    Code: "ST",
    Order: 22
  },
  "ST NC":{
    Name: "Student Niet-Consultant",
    Code: "ST NC",
    Order: 23
  }
};
